import { render, staticRenderFns } from "./MediaSourceLinker.vue?vue&type=template&id=2399a39a&scoped=true&"
import script from "./MediaSourceLinker.vue?vue&type=script&lang=js&"
export * from "./MediaSourceLinker.vue?vue&type=script&lang=js&"
import style0 from "./MediaSourceLinker.vue?vue&type=style&index=0&id=2399a39a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2399a39a",
  null
  
)

export default component.exports